import { render, staticRenderFns } from "./chnlModal.vue?vue&type=template&id=1243da2b&scoped=true&"
import script from "./chnlModal.vue?vue&type=script&lang=js&"
export * from "./chnlModal.vue?vue&type=script&lang=js&"
import style0 from "./chnlModal.vue?vue&type=style&index=0&id=1243da2b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243da2b",
  null
  
)

export default component.exports